import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('delivery_route_zone', 'la zona', 'las zonas')

const importZones = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/delivery_route_zone/import_zones`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron las zonas correctamente.`,
		})
		showSuccessMessage('Se registraron las zonas correctamente.')
		return res.body
	}
}

export default { ...actions, importZones }
